import { useEffect } from "react";
import "../styles/Contents.css";

export default function News() {
    useEffect(() => {
    const elements = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            entry.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
   return (
    <div className="page">

      <section className="about-hero reveal">
        <h1>News & Updates</h1>
        <p>
          Important developments and trends shaping the coaching and education ecosystem in India.
        </p>
      </section>

      <section className="about-section reveal-left">
        <h2>📌 Student Well-Being Regulations</h2>
        <p>
          India has introduced stricter mental-health-focused regulations for coaching institutes to ensure
          student safety, balanced schedules, and stress-free learning environments.
        </p>
      </section>

      <section className="about-section reveal-right">
        <h2>🔍 Increased Oversight of Coaching Centres</h2>
        <p>
          Authorities across multiple states have begun regular inspections of coaching centres,
          enforcing infrastructure standards, counsellor availability, and academic discipline.
        </p>
      </section>

      <section className="about-section reveal-left">
        <h2>📝 Mandatory Registration for Institutes</h2>
        <p>
          Coaching institutions in Karnataka and other regions are now required to register officially
          to maintain quality education standards and transparency.
        </p>
      </section>

      <section className="about-section reveal-right">
        <h2>🎓 Expanding Access to Quality Coaching</h2>
        <p>
          Government and private initiatives are increasingly focused on making quality coaching
          accessible to students from diverse backgrounds.
        </p>
      </section>

      <section className="about-footer reveal">
        <p>
          ACCESS Coaching Institute continues to align with evolving education policies while
          maintaining its commitment to academic excellence and student success.
        </p>
      </section>

    </div>
  );
}
